import React from "react";

const SecondBiWeeklyPicker = () => {
  return (
    <>
      <option value={15}>15th</option>
      <option value={16}>16th</option>
      <option value={17}>17th</option>
      <option value={18}>18th</option>
      <option value={19}>19th</option>
      <option value={20}>20th</option>
      <option value={21}>21st</option>
      <option value={22}>22nd</option>
      <option value={23}>23rd</option>
      <option value={24}>24th</option>
      <option value={25}>25th</option>
      <option value={26}>26th</option>
      <option value={27}>27th</option>
      <option value={28}>28th</option>
    </>
  );
};

export default SecondBiWeeklyPicker;
